import PrefixEnum from '../prefixes'

export default Object.freeze({
    'totalbodybyvogue.gymondo.fitness': PrefixEnum.TOTAL_BODY,
})
